const monthName = new Intl.DateTimeFormat(navigator.language, { month: "long", timeZone: "UTC" });

export const formatMonthName = (dateStr: string): string => monthName.format(new Date(dateStr));
